// Copyright 2022 - 2023 Fewcha. All rights reserved.

import Web3 from "@fewcha/web3";

export const web3 = new Web3();
